<ion-header>
  <ion-toolbar class="or-bg-gradient or-d-flex or-h-56-px">
    <div class="or-align-items-center or-d-flex or-justify-content-between">
      <div class="or-min-w-32-px">
        <img (click)="goBack()" src="assets/icons/back-arrow-icon.svg" class="or-cursor-pointer" />
      </div>

      <div class="or-d-flex or-flex-col or-align-items-center chat-navbar-title-wrap">
        @if (details(); as d) {
          <div (click)="redirect()" class="or-color-white or-head-md chat-navbar-title">
            {{ d.channelName }}
          </div>
          @if (d.channelType === 'multi') {
            <div class="or-color-white or-text-sm text-no-wrap or-mt-4-px">{{ date() }}</div>
          }
        }
      </div>

      <div class="or-align-content-center or-d-flex or-min-w-36-px">
        @if (!hideActions()) {
          <or-icon (click)="dotsClicked()" name="dots-vertical" size="m" class="or-px-12-px or-color-white" />
        }
      </div>
    </div>
  </ion-toolbar>
</ion-header>
